import Vue from 'vue'

Vue.filter('msToMinutes', value => {
  const timeInSecs = Math.round(value / 100) / 10
  var mins = Math.floor(timeInSecs / 60)
  var secs = Math.floor(timeInSecs - mins * 60)
  return `${('00' + mins).slice(-2)}:${('00' + secs).slice(-2)}`
})
